/*
  Promo price preview: see snippets/promo-price.liquid.
  1. Storefront HTML is cached, so the sale window is re-checked here against
     data-promo-start / data-promo-end (unix seconds) and promo / fallback are swapped.
  2. theme.js rewrites [data-product-price-list] on variant change. The promo block (or,
     for a variant not on sale, the label as a nudge) is rebuilt from the [data-promo-pdp]
     JSON the snippet printed.
  3. Harney's discounts exclude subscriptions, so the PDP hides the promo while a selling
     plan is selected (the Loop widget fills the form's selling_plan input).
*/
(function () {
  var nowSeconds = function () { return Math.floor(Date.now() / 1000); };

  var inWindow = function (element) {
    var now = nowSeconds();
    return now >= Number(element.getAttribute('data-promo-start')) && now < Number(element.getAttribute('data-promo-end'));
  };

  var subscribed = function (element) {
    var meta = element.closest('product-meta');
    var form = meta && document.getElementById(meta.getAttribute('form-id'));
    var plan = form && form.querySelector('[name="selling_plan"]');
    return !!(plan && plan.value);
  };

  var applyWindow = function (root) {
    (root || document).querySelectorAll('[data-promo-price], [data-promo-flag]').forEach(function (element) {
      var active = inWindow(element) && !subscribed(element);
      element.hidden = !active;
      if (element.hasAttribute('data-promo-price')) {
        var fallback = element.parentElement.querySelector('[data-promo-fallback]');
        if (fallback) { fallback.hidden = active; }
      }
    });
  };

  var el = function (tag, className, html) {
    var node = document.createElement(tag);
    if (className) { node.className = className; }
    if (html != null) { node.innerHTML = html; }
    return node;
  };

  // The promo block the snippet renders, rebuilt from the [data-promo-pdp] JSON.
  var strikeBlock = function (data, prices) {
    var block = el('div', 'promo-price');
    block.setAttribute('data-promo-price', '');
    block.setAttribute('data-promo-start', data.start);
    block.setAttribute('data-promo-end', data.end);
    var sale = el('span', 'price price--highlight' + (data.large ? ' price--large' : ''), prices[0]);
    sale.prepend(el('span', 'visually-hidden', data.saleText));
    var regular = el('span', 'price price--compare', prices[1]);
    regular.prepend(el('span', 'visually-hidden', data.regularText));
    var label = el('span', 'promo-price__label');
    label.textContent = data.label;
    block.append(sale, regular, label);
    return block;
  };

  var nudge = function (data) {
    var label = el('span', 'promo-price__label');
    label.setAttribute('data-promo-flag', '');
    label.setAttribute('data-promo-start', data.start);
    label.setAttribute('data-promo-end', data.end);
    label.textContent = data.label;
    return label;
  };

  var watchProductPrices = function () {
    document.querySelectorAll('[data-product-price-list]').forEach(function (priceList) {
      var script = priceList.querySelector('[data-promo-pdp]');
      if (!script || priceList.promoWatched) { return; }
      priceList.promoWatched = true;

      var data = JSON.parse(script.textContent);
      var variantId = null;
      var meta = priceList.closest('product-meta');
      var form = meta && document.getElementById(meta.getAttribute('form-id'));

      if (form) {
        form.addEventListener('variant:changed', function (event) {
          variantId = event.detail.variant ? String(event.detail.variant.id) : null;
        });
      }

      // theme.js replaces the price list children on variant change. Re-add the promo for the
      // new variant: struck price when it is on sale, otherwise the label as a nudge (a
      // variant-level sale names the sale size in its label).
      new MutationObserver(function () {
        if (!variantId || !(variantId in data.variants)) { return; }
        if (priceList.querySelector('[data-promo-price], [data-promo-flag]')) { return; }
        var prices = data.variants[variantId];
        if (prices) {
          var fallback = el('div', 'promo-fallback');
          fallback.setAttribute('data-promo-fallback', '');
          priceList.querySelectorAll(':scope > .price:not(.text--subdued)').forEach(function (price) { fallback.appendChild(price); });
          priceList.prepend(strikeBlock(data, prices), fallback);
        } else {
          var unit = priceList.querySelector(':scope > .price.text--subdued');
          priceList.insertBefore(nudge(data), unit);
        }
        applyWindow(priceList);
      }).observe(priceList, { childList: true });
    });
  };

  var start = function () {
    applyWindow();
    watchProductPrices();
    // Loop sets selling_plan without a reliable event; re-check after any purchase option change.
    ['click', 'change'].forEach(function (type) {
      document.addEventListener(type, function (event) {
        if (event.target.closest && event.target.closest('.loop-widget-container, product-form, form[action*="/cart/add"]')) {
          setTimeout(function () { applyWindow(); }, 50);
        }
      }, true);
    });
    setInterval(applyWindow, 30000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
